import React from "react";
import { Box, FormHelperText, Stack, Typography } from "@mui/material";
import { InputControl } from "../../../shared/components/InputControl";
import { Loader } from "../../../shared/components/Loader";

const ActionSection = ({ title, subtitle, rightSection }) => (
  <Stack direction="row" gap="16px" justifyContent="space-between">
    <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      <Typography
        sx={{ fontWeight: 500, fontSize: "16px", lineHeight: "19px" }}
      >
        {title}
      </Typography>
      {Array.isArray(subtitle) ? (
        subtitle.map((item) => (
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "12px",
              lineHeight: "14px",
              color: "text.secondary",
            }}
          >
            {item}
          </Typography>
        ))
      ) : (
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "14px",
            color: "text.secondary",
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
    {rightSection}
  </Stack>
);

export const AddOrEditUnit = (props) => {
  const { onChange, state, validator, unitDetails } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        padding: "16px 20px !important",
      }}
    >
      {unitDetails?.isLoading ? (
        <Loader />
      ) : (
        <React.Fragment>
          <InputControl
            type="text"
            label="Unit Name"
            name="name"
            sx={{
              bgcolor: state.data.is_default ? "#F5F8FC" : "",
            }}
            error={validator.current.message(
              "Unit Name",
              state.data.name,
              "required"
            )}
            helperText={validator.current.message(
              "Unit Name",
              state.data.name,
              "required"
            )}
            onChange={onChange}
            value={state?.data?.name}
            fullWidth
            required
            disabled={state?.data?.is_default ? true : false}
          />

          <InputControl
            type="text"
            label="Unit Symbol"
            name="symbol"
            sx={{
              bgcolor: state?.data?.is_default ? "#F5F8FC" : "",
            }}
            error={validator.current.message(
              "Unit Symbol",
              state.data.symbol,
              "required"
            )}
            helperText={validator.current.message(
              "Unit Symbol",
              state.data.symbol,
              "required"
            )}
            onChange={onChange}
            value={state?.data?.symbol}
            fullWidth
            required
            disabled={state?.data.is_default ? true : false}
          />

          <ActionSection
            title="Ignore Calculation?"
            subtitle="This unit doesn't take to calculate if this option is on. Just for the
        recipe."
            rightSection={
              <InputControl
                type="switch"
                name="ignore"
                onChange={(e) => {
                  onChange({
                    target: {
                      name: "ignore",
                      value: e.target.checked,
                    },
                  });
                }}
                checked={state?.data?.ignore}
                {...{ inputProps: { "aria-label": "Switch demo" } }}
                defaultChecked
                disabled={state?.data.is_default ? true : false}
                edge="end"
              />
            }
          />

          <ActionSection
            title="No. Of Decimal Places*"
            subtitle={[
              "Decimal places is for display purposes only.",
              "Eg: 3 decimal places means “0.001",
            ]}
            rightSection={
              <InputControl
                type="number"
                name="no_of_decimals"
                onChange={onChange}
                sx={{ width: "97px" }}
                value={state?.data?.no_of_decimals}
              />
            }
          />

          <FormHelperText sx={{ ml: "auto", color: "error.main" }}>
            {validator.current.message(
              "No. Of Decimal Places",
              state.data.no_of_decimals,
              "required||regex:^[0-9]+$||min:0,num||max:4,num"
            )}
          </FormHelperText>
        </React.Fragment>
      )}
    </Box>
  );
};
